export let Global = {
    camera: null
}